import PaginationData from 'types/models/PaginationData';
import { StockRecipe, StockRecipeItem } from 'types/models/StockMovement';
import axiosInstance from './axios';
import joinURLParams from 'utils/joinUrlParams';
import { parseGlobalProduct } from './stockServices';

export const getRecipes = async (
  page?: number,
  searchTerm?: string,
  extraParams?: Record<string, any>,
): Promise<PaginationData<StockRecipe>> => {
  let url = joinURLParams({ page, searchTerm }, 'stock/recipes');
  if (extraParams) {
    url = joinURLParams(extraParams, url);
  }
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url,
    });
    return {
      currentPage: data.current_page,
      data: parseRecipes(data.data),
      perPage: data.per_page,
      total: data.total,
    };
  } catch (error) {
    throw error;
  }
};

export const getRecipesSimple = async (venueId: string): Promise<StockRecipe[]> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: joinURLParams({ simple: true, venueId }, 'stock/recipes'),
    });
    return parseRecipes(data);
  } catch (error) {
    throw error;
  }
};

export const getStockRecipe = async (id: string | number): Promise<StockRecipe> => {
  try {
    console.log('getStockRecipe', id);
    const { data } = await axiosInstance({
      method: 'get',
      url: `stock/recipes/${id}`,
    });
    return parseRecipe(data);
  } catch (error) {
    throw error;
  }
};

export const updateStockRecipe = async (id: number, payload: any): Promise<StockRecipe> => {
  try {
    const { data } = await axiosInstance({
      method: 'put',
      url: `stock/recipes/${id}`,
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteRecipe = async (id: string | number): Promise<void> => {
  try {
    const { data } = await axiosInstance({
      method: 'delete',
      url: `stock/recipes/${id}`,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

const parseRecipes = (recipes: unknown[]): StockRecipe[] => {
  return recipes.map(parseRecipe);
};

const parseRecipe = (recipe: any): StockRecipe => {
  return {
    id: recipe.id,
    globalProductId: recipe.global_product_id,
    globalProduct: recipe.global_product ? parseGlobalProduct(recipe.global_product) : undefined,
    items: recipe.items ? parseRecipeItems(recipe.items) : undefined,
  };
};

const parseRecipeItems = (items: any[]): StockRecipeItem[] => {
  return items.map(parseRecipeItem);
};

const parseRecipeItem = (item: any): StockRecipeItem => {
  return {
    id: item.id,
    ingredientGlobalProductId: item.ingredient_global_product_id,
    quantity: item.quantity,
    ingredient: item.ingredient ? parseGlobalProduct(item.ingredient) : undefined,
  };
};
